import React, { useState } from "react";
import axios from "axios";
import { toast } from 'react-toastify';



function RegistrationForm({ onClose }) {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    password: "",
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);


  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post("https://fnm-backend.aibc-robotics.com/register", {
        first_name: formData.first_name,
        last_name: formData.last_name,
        email: formData.email,
        password: formData.password
      });
    setShowSuccess(true); // pokaže modal

    } catch (error) {
      toast.error("Napaka pri registraciji:", error);
      //alert("Napaka pri registraciji.");
    }
  };


  return (


    <div className="bg-white rounded-xl shadow-lg w-full max-w-2xl p-8 relative">
      <button
        onClick={onClose}
        className="absolute top-4 right-4 text-gray-500 hover:text-red-600 text-xl"
      >
        ×
      </button>

      <h2 className="text-2xl font-semibold text-center mb-6">Registracija</h2>

      <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="col-span-1">
          <label className="block text-sm font-medium text-gray-700">Ime</label>
          <input
            name="first_name"
            type="text"
            value={formData.first_name}
            onChange={handleChange}
            required
            className="mt-1 w-full border rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div className="col-span-1">
          <label className="block text-sm font-medium text-gray-700">Priimek</label>
          <input
            name="last_name"
            type="text"
            value={formData.last_name}
            onChange={handleChange}
            required
            className="mt-1 w-full border rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div className="col-span-1 md:col-span-2">
          <label className="block text-sm font-medium text-gray-700">E-pošta</label>
          <input
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            required
            className="mt-1 w-full border rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div className="col-span-1 md:col-span-2">
          <label className="block text-sm font-medium text-gray-700">Geslo</label>
          <input
            name="password"
            type="password"
            value={formData.password}
            onChange={handleChange}
            required
            className="mt-1 w-full border rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        {showSuccess && (
            <div className="fixed inset-0 bg-black bg-opacity-40 z-50 flex items-center justify-center">
              <div className="bg-white p-6 rounded-xl shadow-xl text-center w-[300px]">
                <h2 className="text-lg font-semibold mb-2">✅ Uspešna registracija</h2>
                <p className="text-sm text-gray-600 mb-4">Zdaj se lahko prijaviš.</p>
                <button
                  onClick={() => {
                    setShowSuccess(false);
                    onClose(); // zapri modal
                  }}
                  className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                >
                  Zapri
                </button>
              </div>
            </div>
          )}

        <div className="col-span-1 md:col-span-2">
          <button
            type="submit"
            className="w-full py-2 bg-blue-600 text-white rounded-md font-semibold hover:bg-blue-700 transition"
          >
            Registriraj se
          </button>
        </div>

        {error && <p className="col-span-2 text-red-600 text-sm">{error}</p>}
        {success && <p className="col-span-2 text-green-600 text-sm">Uspešno registriran!</p>}
      </form>
    </div>
  );
}

export default RegistrationForm;
